/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */

export enum EventNames {
  FIRST_PAINT = 'firstPaint',
  FIRST_CONTENTFUL_PAINT = 'firstContentfulPaint',
}
